import { render } from "./AdditionalView.vue?vue&type=template&id=74c11e62"
import script from "./AdditionalView.vue?vue&type=script&lang=js"
export * from "./AdditionalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__